import { Fragment, useEffect } from 'react';

import { Bottomsheet, HeadTitle, Spacer } from 'oui';
import { AlignBox } from '../../etc/LBox/LBox';
import scrollLock from '../../../application/helper/scrollLock';
import REPAYMENT from '../../../application/staticData/info/REPAYMENT';

const sclk = scrollLock();

interface IRepaymentInfo {
  isShow: boolean;
  handleClickCloseInfoBottom: () => void;
  isBottomSheet: boolean;
}

const RepaymentInfoBottomSheet = ({
  isShow,
  handleClickCloseInfoBottom,
  isBottomSheet,
}: IRepaymentInfo) => {
  useEffect(() => {
    if (isShow) {
      sclk.enableScrollLock();
    } else {
      sclk.disableScrollLock();
    }

    return () => {
      sclk.disableScrollLock();
    };
  }, [isShow]);

  return (
    <Bottomsheet
      isOpen={isShow}
      onClose={handleClickCloseInfoBottom}
      disableScrollLock={true}
      backdrop={!isBottomSheet}
      children={
        <>
          <HeadTitle
            textTitle={'상환 방식'}
            buttonIconName={'CloseSharp'}
            onClickButton={handleClickCloseInfoBottom}
          />
          <div
            style={{
              overflowY: 'scroll',
              height: isBottomSheet ? `80vh` : ``,
            }}
          >
            <Spacer size={'md'} />
            {REPAYMENT.map((item, index) => {
              return (
                <Fragment key={item.id}>
                  <HeadTitle textTitle={item.title} />
                  <AlignBox>
                    <img src={item.image} alt={item.title} />
                  </AlignBox>
                  {index < REPAYMENT.length - 1 && <Spacer size={'md'} />}
                </Fragment>
              );
            })}
            <Spacer size={'md'} />
          </div>
        </>
      }
    />
  );
};

export default RepaymentInfoBottomSheet;
